// utils/verifiedUsers.js
const verifiedUsers = ['solbook', 'solsnap', 'solstream', 'solmail', 'nutflex', 'NutFlex', 'soltalkai', 'churchofthescf', 'church'];
export default verifiedUsers;
